"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivityTrackingContract = void 0;
var ActivityTrackingContract = /** @class */function () {
  function ActivityTrackingContract(surveyId, trackingSet) {
    this.surveyId = surveyId;
    this.trackingSet = trackingSet;
  }
  return ActivityTrackingContract;
}();
exports.ActivityTrackingContract = ActivityTrackingContract;